import styled from '@emotion/styled';

const ContainerScrollable = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  height: 50px;
  justify-content: flex-start;
  overflow-x: scroll;
  margin: .5rem 0;

  @media (min-width: 1024px) {
    justify-content: center;
    overflow-x: visible;
  }
`;

export default ContainerScrollable;
